<template lang="pug">
    div(class="caption font-weight-bold primary--text") Single / Multi Used
        v-radio-group(dense v-model="single" @change="onSelect" :readonly="readonly")
            v-radio(label="Single Used" :value="true" color="primary" )
            v-radio(label="Multi Used" :value="false" color="primary")
</template>
<script>
export default {
    name: "FRadioVirtualAccountSingle",
    props: ["value","readonly"],
    data() {
        return {
            single: null
        };
    },
    mounted() {
        this.doInitModel(this.value);
    },
    watch: {
        value(val) {
            this.doInitModel(val);
        }
    },
    methods: {
        doInitModel(values) {
            this.single = values;
            this.onSelect();
        },
        onSelect() {
            this.$emit("input", this.single);
            this.$emit("select", this.single);
        }
    }
};
</script>